'use client';

import React from 'react';
import { Box } from '@chakra-ui/react';

// Design specs from Figma
const LOADER_HEIGHT = '8px';
const PRIMARY_COLOR = '#6F3FD7'; // Primary/400
const BACKGROUND_COLOR = '#E1D3FF'; // Primary/100

// Bar widths as percentage of screen width
const DESKTOP_BAR_WIDTH = '35%';
const MOBILE_BAR_WIDTH = '45%';
interface PageTransitionLoaderProps {
  isLoading: boolean;
}

/**
 * Page transition loading indicator that appears at the top of the viewport.
 * Displays a brand-colored animated progress bar during page navigation.
 * Bar width is responsive: 35% on desktop, 45% on mobile.
 *
 * @param isLoading - Whether the loading animation should be displayed
 */
export const PageTransitionLoader = ({
  isLoading
}: PageTransitionLoaderProps) => {
  if (!isLoading) {
    return null;
  }
  return <>
      <style>
        {`
          @keyframes pageTransitionLoader {
            0% {
              background-position: -100% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
          .page-transition-loader {
            animation: pageTransitionLoader 1s linear infinite;
          }
          @media (min-width: 768px) {
            .page-transition-loader {
              animation: pageTransitionLoader 1.5s linear infinite;
            }
          }
        `}
      </style>
      <Box className="page-transition-loader" position="fixed" top={0} left={0} right={0} height={LOADER_HEIGHT} zIndex="var(--ss-z-index-overlay)" backgroundColor={BACKGROUND_COLOR} backgroundImage={`linear-gradient(${PRIMARY_COLOR} 0 0)`} backgroundSize={{
      base: `${MOBILE_BAR_WIDTH} 100%`,
      tablet: `${DESKTOP_BAR_WIDTH} 100%`
    }} backgroundRepeat="no-repeat" aria-label="Page loading" role="progressbar" aria-busy="true" data-sentry-element="Box" data-sentry-source-file="PageTransitionLoader.tsx" />
    </>;
};
export default PageTransitionLoader;